import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { ThemingService } from '@fino-ui/theming';
import { TranslateService } from '@fino-ui/translation';
import { NgxLoadingModule } from 'ngx-loading';
import { LocalStorageService } from 'ngx-webstorage';
import { FreshdeskComponent } from './components/freshdesk/freshdesk.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SentryErrorService } from './core/error/sentry-error.service';
import { LoadingService } from './core/interceptors/loading.service';

@Component({
  selector: 'app-root',
  styleUrl: './app.component.sass',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgxLoadingModule,
    FreshdeskComponent,
    RouterOutlet,
    NavbarComponent,
  ],
})
export class AppComponent implements OnInit {
  constructor(
    private storage: LocalStorageService,
    private translateService: TranslateService,
    private sentryErrorService: SentryErrorService,
    private loadingService: LoadingService,
    private themingService: ThemingService,
  ) {}

  get loading() {
    return this.loadingService.loading;
  }

  loadingSpinnerConfig = {
    primaryColour: this.themingService.getPrimaryColor(),
    backdropBorderRadius: '3px',
  };

  ngOnInit(): void {
    const lang = this.storage.retrieve('language');
    if (lang) {
      this.translateService.use(lang);
    }

    this.sentryErrorService.initSentry();
  }
}
